import React, { FC, useEffect } from "react";
import map from "lodash/map";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import cn from "clsx";

import { Product } from "@/services/productService";
import PlpAnalytics from "@/services/analytics/main/plp";
import { useAppSelector } from "@/redux/store";
import { selectCdnImageSettings } from "@/util/selectors";
import { useRouteSlug } from "@/hooks";
import ContentImage from "@/components/content/contentImage";

import "./style.scss";

const RelatedProducts: FC<{
  product: Product;
}> = ({ product }) => {
  const { t } = useTranslation("productDetails");
  const cdnImageSettings = useAppSelector(selectCdnImageSettings);
  const routeSlug = useRouteSlug();

  const relatedItemsLength = product.relatedProducts?.length;

  useEffect(() => {
    if (relatedItemsLength) {
      PlpAnalytics.impressions({
        items: product.relatedProducts,
        listHeading: `${relatedItemsLength} ${
          relatedItemsLength === 1 ? t("similarProduct") : t("similarProducts")
        }`
      });
    }
  }, [relatedItemsLength]);

  if (!relatedItemsLength) return null;

  return (
    <div className="related_product_items_resp_wrapper">
      <div className="related_product_items_resp">
        <p>{`${t("availableColor")}: ${relatedItemsLength}`}</p>
        <div className="related_product_items_content">
          {map(product.relatedProducts, relatedItem => (
            <div
              key={relatedItem.id}
              className={cn("related_product_item", {
                selected: relatedItem.id === product.id
              })}
            >
              <Link
                to={{
                  pathname: `/${routeSlug}/${relatedItem.url}`,
                  state: { isAvailableColorItem: true }
                }}
                className="product_item"
              >
                <ContentImage
                  url={cdnImageSettings?.thumb}
                  img={relatedItem.captionImageURL}
                  lazyLoad={true}
                  alt={relatedItem.title?.defaultValue ?? "Product image"}
                />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RelatedProducts;
